/**
 * Created by contrapro on 03/04/2018
 */

// import { Observable } from 'rxjs/Observable';
import { Observable } from 'rxjs';
import { getWebHost } from '../util/serverUtil';


export const api = {
    //--------- User -------------------
    getUser(objectID) {
        return _get(getWebHost() + '/user/' + objectID);
    },

    updateUser(objectID, bodyData, session) {
        return _put(getWebHost() + '/user/' + objectID, bodyData, session);
    },

    login(bodyData) {
        return _post(getWebHost() + '/user/', bodyData);
    },

    //-------- message
    loadMessageList(userObjectId) {
        //console.log('--- service loadMessageList ---')
        const query = {
            where: { userObjectId: userObjectId, read: 'false' }// where={"pubUser":"LeanCloud官方客服"}
            // keys: '-userObjectId'
        };
        return _get(getWebHost() + '/message/', query);
    },

    setMessageRead(msgObjectId, session) {
        return _put(getWebHost() + '/message/' + msgObjectId, { read: 'true' }, session);
    },

    //------- wish
    addWish(type, userObjectId, session) {
        return _post(getWebHost() + '/wish/', {
            type: type,
            used: 'false', //注意，这里用字符串
            hp: 0,
            user: {
                "__type": "Pointer",
                "className": "_User",
                "objectId": userObjectId
            }
        }, session);
    },

    loadWishes(onlyMine, userObjectId) {
        //console.log('--- service loadMessageList ---')
        const query = onlyMine
            ? {
                where: { used: 'false', user: { "__type": "Pointer", "className": "_User", "objectId": userObjectId } },// where={"pubUser":"LeanCloud官方客服"}
                //include: "userObject"  //我的愿望不用展开user
                // keys: '-userObjectId'
            }
            : {
                where: { used: 'false' },
                include: "user"     //直接展开user，供点击的时候方便
            };
        return _get(getWebHost() + '/wish/', query);
    },

    powerWish(wishID, hp, pointUserObjectId, session) {
        return _put(getWebHost() + '/wish/' + wishID, { hp: hp, pointUserObjectId: pointUserObjectId }, session);
    },

    useWish(wishId, ownerUserObjectId, wishNum, session) {
        return _put(getWebHost() + '/wish/use/' + wishId, {userObjectId : ownerUserObjectId, wishNum: wishNum}, session);
    },

    //--------light
    //光点抽奖
    lightLottery(userObjectId, session) {
        return _put(getWebHost() + '/light/lottery', { userObjectId: userObjectId }, session);
    },

    //光点收集
    lightCollect(userObjectId, type, session) {
        return _put(getWebHost() + '/light/collect', {
            type: type,
            user: {
                "__type": "Pointer",
                "className": "_User",
                "objectId": userObjectId
            }
        }, session);
    },

    loadLightCollect(onlyMine, userObjectId) {
        //console.log('--- service loadMessageList ---')
        const query = onlyMine ?
            {
                where: {
                    released: 'false',
                    user: { "__type": "Pointer", "className": "_User", "objectId": userObjectId },
                }// where={"pubUser":"LeanCloud官方客服"}
                // keys: '-userObjectId'
            } :
            {
                where: { released: 'false' }
            };
        return _get(getWebHost() + '/light/', query);
    },

    //------- lightQA
    addLightQA( userObjectId, answers, session) {
        console.log('addLightQA', userObjectId, answers, session);
        return _post(getWebHost() + '/light/qa', {
            userObjectId: userObjectId,
            answers: answers,
        }, session);
    },

    //----- release lights
    releaseLights( userObjectId, session ){
        return _put(getWebHost() + '/light/release/all', {
            userObjectId: userObjectId
        }, session);
    },

    //------- card
    addCard(cardId) {
        return _get(getWebHost() + '/card/add', { cardId: cardId });
    }

};


const _get = (url, query) => {
    return Observable.create(observer => { // var observable = Rx.Observable.create(function subscribe(observer) {
        //console.log('====---- _get', url, query);
        const request = require('superagent');
        request
            .get(url)
            .query(query)
            .redirects(0)
            .end(function (err, res) {
                if (err || !res.ok) {
                    //console.log('------------');
                    //console.log('Oh no! leanGet error');
                    observer.error(err);
                } else {
                    //console.log('------------');
                    //console.log('leanGet got: ' ,'status: ',res.status ,'body: ',(res.body));
                    try {
                        observer.next(res);
                        observer.complete();
                    } catch (e) {
                        observer.error(e);
                    }
                }
            });
    });
};

const _post = (url, bodyData, session) => {
    return Observable.create(observer => { // var observable = Rx.Observable.create(function subscribe(observer) {
        const request = require('superagent');
        //console.log('-====--- _post', url, bodyData);
        request
            .post(url)
            .send(bodyData)
            .set('X-Lc-Session', session)
            .set('Content-Type', 'application/json')
            .redirects(0)
            .end(function (err, res) {
                if (err || !res.ok) {
                    //console.log('------------');
                    //console.log('Oh no! leanPost error');
                    observer.error(err);
                } else {
                    //console.log('------------');
                    //console.log('leanPost got: ', 'status: ',res.status ,'body: ',(res.body));
                    try {
                        observer.next(res);
                        observer.complete();
                    } catch (e) {
                        observer.error(e);
                    }
                }
            });
    });
};

const _put = (url, bodyData, session) => {
    return Observable.create(observer => {
        const request = require('superagent');
        //console.log('-=====--- _put', url, bodyData);
        // if (session && session.length > 0)
        //      request.set('X-Lc-Session', session);

        request
            .put(url)
            .send(bodyData)
            .set('X-Lc-Session', session)
            .set('Content-Type', 'application/json')
            .redirects(0)
            .end(function (err, res) {
                if (err || !res.ok) {
                    //console.log('------------');
                    //console.log('Oh no! leanPut error');
                    observer.error(err);
                } else {
                    //console.log('------------');
                    //console.log('leanPut got: ', 'status: ',res.status ,'body: ',(res.body));
                    try {
                        observer.next(res);
                        observer.complete();
                    } catch (e) {
                        observer.error(e);
                    }
                }
            });
    });
};



// WEBPACK FOOTER //
// ./src/service/AppService.js